<template>
  <div class="release">
    <ul class="releaseList">
      <li>
        <p>发布类目</p>
        <input type="text" v-model="release.category" placeholder="请输入发布类目" />
      </li>
      <li>
        <p>发布信息标题</p>
        <input type="text" v-model="release.title" placeholder="请输入发布信息标题" />
      </li>
      <li>
        <p>联系人</p>
        <input type="text" v-model="release.contact" placeholder="请输入联系人" />
      </li>
      <li>
        <p>邮箱</p>
        <input type="text" v-model="release.email" placeholder="请输入邮箱" />
      </li>
      <li>
        <p>手机号或电话</p>
        <input type="text" v-model="release.mobile" placeholder="请输入手机号或电话" />
      </li>
      <li>
        <p>详细内容</p>
        <div>
          <quill-editor
            class="editor"
            ref="myQuillEditor"
            v-model="release.content"
            :options="editorOption"
          />
        </div>
      </li>
    </ul>
    <div class="submitBtn" @click="submitBtn">确认并提交审核</div>
    <div class="releaseToast">我承诺发布真实有效的信息，审核通过后客服将与您联系</div>

    <!-- TOAST -->
    <Tips ref="tipsLarey"></Tips>

  </div>
</template>
<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import Tips from '../components/tips';


export default {
  name:'release',
  data() {
    return {
      release:{
        category:'',
        title:'',
        contact:'',
        email:'',
        mobile:'',
        content:'',
      },
      content: '',
      editorOption: {
        placeholder: "请在这里输入",
        modules:{
            toolbar:[
                ['bold', 'italic', 'underline'],          // 加粗，斜体，下划线，删除线'strike'
                [{ 'size': [ "small", false, "large", "huge"] }],    // 字体大小
                [{ 'color': [] }],            // 字体颜色，字体背景颜色, { 'background': [] }
                ['clean'],      // 清除字体样式
                // ["image","video"]       // 链接、图片、视频
            ],
            // Vue-Quill-Editor富文本编辑器-工具菜单栏配置-参考
            toolbar: [
                ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
                ["blockquote", "code-block"], // 引用  代码块
                [{ header: 1 }, { header: 2 }], // 1、2 级标题
                [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
                [{ script: "sub" }, { script: "super" }], // 上标/下标
                [{ indent: "-1" }, { indent: "+1" }], // 缩进
                // [{'direction': 'rtl'}],                         // 文本方向
                [{ size: ["small", false, "large", "huge"] }], // 字体大小
                [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
                [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
                [{ font: [] }], // 字体种类
                [{ align: [] }], // 对齐方式
                ["clean"], // 清除文本格式
                // ["link", "image", "video"] // 链接、图片、视频
            ],
        },
        syntax: true,  //语法检测
      },
    }
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill
    }
  },
  mounted() {
    console.log('this is current quill instance object', this.editor)
  },
  methods:{
    submitBtn(){
      
      let mReg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.(com|cn|net)$/;
      
      if(this.release.category == ''){
        this.$refs.tipsLarey.tipsShow('发布类目不能为空');
      }else if(this.release.title == ''){
        this.$refs.tipsLarey.tipsShow('发布信息标题不能为空');
      }else if(this.release.contact == ''){
        this.$refs.tipsLarey.tipsShow('联系人不能为空');
      }else if(this.release.email == ''){
        this.$refs.tipsLarey.tipsShow('邮箱不能为空');
      }else if(!mReg.test(this.release.email)){
        this.$refs.tipsLarey.tipsShow('邮箱格式不正确');
      }else if(this.release.mobile == ''){
        this.$refs.tipsLarey.tipsShow('手机号或电话不能为空');
      }else if(this.release.content == ''){
        this.$refs.tipsLarey.tipsShow('详情内容不能为空');
      }else{
        this.$refs.tipsLarey.tipsShow('提交成功');
        this.release = {
          category:'',
          title:'',
          contact:'',
          email:'',
          mobile:'',
          content:'',
        }
      }
    },
  },
  components: {
    quillEditor,
    Tips,
  },
}
</script>
<style lang="scss" scoped>
  .release{
    width: $navWidth;
    padding: 30px 30px 50px;
    margin: 20px auto 20px;
    @include h-radius(3px);
    @include h-bgColor(var(--colorFF));
    .releaseList{
      li{
        margin-bottom: 15px;
        p{
          // font-weight: bold;
          margin-bottom: 5px;
          @include h-fontSize(var(--color33),14px,28px);
        }
        input{
          width:100%;
          text-indent: 15px;
          border:0;
          @include h-bgColor(var(--colorF5));
          @include h-fontSize(var(--color22),14px,42px);
          &::placeholder{
            font-size: 12px;
          }
        }
      }
    }
    .submitBtn{
      cursor: pointer;
      margin:30px auto 0;
      transition: opacity 0.3s;
      @include h-btn(100%, 42px, 14px, $colorFF, 3px, 0, $colorF6, false, none);
      &:hover{
        opacity: 0.8;
      }
    }
    .releaseToast{
      margin:20px auto 0;
      text-align: center;
      @include h-fontSize($color66,12px,20px);
    }
  }
</style>
<style lang="scss">
  // .editor,
  .ql-container{
    height: 400px;
  }
  .ql-container.ql-snow,
  .ql-toolbar.ql-snow{
    border:1px solid var(--color44);
  }
  .ql-editor{
    color:var(--color00);
  }
  .ql-editor.ql-blank::before{
    color:var(--color99);
  }
</style>
